import { Button, HStack, Textarea } from "@chakra-ui/react";
import { KeyboardEvent, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ChatType } from "../../models/Chat";
import useChatState from "../../state/chat.state";

type Props = {
  chatType: ChatType;
};

export default function ChatInputBar({ chatType }: Props) {
  const { t } = useTranslation();
  const {
    messageWithTeacher,
    messageWithStudents,
    isChatWithTeacherDisabled,
    isChatWithStudentsDisabled,
    setMessageWithTeacher,
    setMessageWithStudents,
    //
  } = useChatState();
  const [typedMessage, setTypedMessage] = useState<string>("");

  useEffect(() => {
    if (
      (chatType === "chat-with-teacher" && !messageWithTeacher) ||
      (chatType === "chat-with-students" && !messageWithStudents)
    ) {
      setTypedMessage("");
    }
  }, [messageWithStudents, messageWithTeacher, chatType]);

  const onSend = useCallback(() => {
    if (chatType === "chat-with-teacher") {
      setMessageWithTeacher(typedMessage);
    } else {
      setMessageWithStudents(typedMessage);
    }
  }, [setMessageWithStudents, setMessageWithTeacher, chatType, typedMessage]);

  const onKeyDown = useCallback(
    (event: KeyboardEvent<HTMLTextAreaElement>) => {
      if (event.key === "Enter" && !event.shiftKey && typedMessage) {
        onSend();
        event.preventDefault();
      }
    },
    [onSend, typedMessage],
  );

  if (
    (chatType === "chat-with-teacher" && isChatWithTeacherDisabled) ||
    (chatType === "chat-with-students" && isChatWithStudentsDisabled)
  ) {
    return null;
  }

  return (
    <HStack flexGrow={1} alignItems="center" gap={4} p={4}>
      <Textarea
        value={typedMessage}
        onChange={(element) => setTypedMessage(element.target.value)}
        rows={1}
        bg="white"
        onKeyDown={onKeyDown}
      />
      <Button
        bg="primary.DEFAULT"
        color="white"
        isDisabled={!typedMessage}
        onClick={onSend}
      >
        {t("common.buttons.send")}
      </Button>
    </HStack>
  );
}
